import { combineReducers, configureStore, Tuple } from '@reduxjs/toolkit';
import createSagaMiddleware from 'redux-saga';
import { spawn } from 'redux-saga/effects';
import { EnhancedStore } from '@reduxjs/toolkit/src/configureStore';
import { useDispatch } from 'react-redux';
import { Store } from 'redux';
import { moduleName as authModuleName, auth, saga as authSaga } from './auth';
import { moduleName as userModuleName, user, saga as userSaga } from './user';
import { moduleName as commonModuleName, common, saga as commonSaga } from './common';
import { moduleName as categoryModuleName, category, saga as categorySaga } from './category_example';
import { moduleName as articleModuleName, article, saga as articleSaga } from './article';
import { moduleName as tagModuleName, tag, saga as tagSaga } from './tag';
import { moduleName as countryModuleName, country, saga as countrySaga } from './country';
import { moduleName as reportModuleName, report, saga as reportSaga } from './report';
import { moduleName as businessModuleName, business, saga as businessSaga } from './business';
import { moduleName as commentModuleName, comment, saga as commentSaga } from './comment';
import { moduleName as ticketModuleName, ticket, saga as ticketSaga } from './ticket';

export const sagaMiddleware = createSagaMiddleware();

const store: Store = configureStore({
  reducer: combineReducers({
    [authModuleName]: auth.reducer,
    [userModuleName]: user.reducer,
    [commonModuleName]: common.reducer,
    [categoryModuleName]: category.reducer,
    [articleModuleName]: article.reducer,
    [tagModuleName]: tag.reducer,
    [countryModuleName]: country.reducer,
    [reportModuleName]: report.reducer,
    [businessModuleName]: business.reducer,
    [commentModuleName]: comment.reducer,
    [ticketModuleName]: ticket.reducer,
  }),
  middleware: () => new Tuple(sagaMiddleware),
  devTools: process.env.REACT_APP_ENV !== 'production',
});

// eslint-disable-next-line @typescript-eslint/no-unused-vars
const storeType = store as EnhancedStore;

export type RootState = ReturnType<typeof storeType.getState>;
export type AppDispatch = typeof store.dispatch;

// eslint-disable-next-line @typescript-eslint/no-unused-vars
export const useAppDispatch = () => useDispatch<AppDispatch>();

sagaMiddleware.run(function* runSaga() {
  yield spawn(authSaga, store);
  yield spawn(commonSaga, store);
  yield spawn(userSaga);
  yield spawn(categorySaga);
  yield spawn(articleSaga);
  yield spawn(tagSaga);
  yield spawn(countrySaga);
  yield spawn(reportSaga);
  yield spawn(businessSaga);
  yield spawn(commentSaga);
  yield spawn(ticketSaga);
});

export default store;
